import React from 'react';
import { graphql } from 'react-apollo';
import FormVentaSello from '../../formularios/FormVentaSello';
import { Select, Tooltip, Button, InputNumber, Checkbox } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import getTiposCertificaciones from '../../../graphql/querys/tramites/getTiposCertificaciones.graphql';
import _ from 'lodash';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

@graphql(getTiposCertificaciones)
class FormCertificacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      id_TipoCertificacion: '',
      cantidad: 0,
      existeVenta: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit({
          id_TipoCertificacion: values.id_TipoCertificacion,
          cantidad: values.cantidad,
          existeVenta: this.state.existeVenta,
        });
      }
    });
  };

  onFinalizar = (detalles, datosPonset, extras) => {
    // eslint-disable-next-line no-unused-vars
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let datos = {
          id_TipoCertificacion: this.props.form.getFieldValue(
            'id_TipoCertificacion'
          ),
          cantidad: this.props.form.getFieldValue('cantidad'),
          existeVenta: this.state.existeVenta,
          detalles,
          datosPonset,
          extras,
        };
        this.props.onSubmit(datos);
      }
    });
  };

  crearVentaCompleta = (detalles, datosPonset, extras) => {
    // eslint-disable-next-line no-unused-vars
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let datos = {
          id_TipoCertificacion: this.props.form.getFieldValue(
            'id_TipoCertificacion'
          ),
          cantidad: this.props.form.getFieldValue('cantidad'),
          existeVenta: this.state.existeVenta,
          detalles,
          datosPonset,
          extras,
        };
        this.props.generarCertificacionCompleta(datos);
      }
    });
  };

  onFinalizarMP = (detalles, datosMP, extras) => {
    // eslint-disable-next-line no-unused-vars
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let datos = {
          id_TipoCertificacion: this.props.form.getFieldValue(
            'id_TipoCertificacion'
          ),
          cantidad: this.props.form.getFieldValue('cantidad'),
          existeVenta: this.state.existeVenta,
          detalles,
          datosMP,
          extras,
        };
        this.props.generarCertificacionCompleta(datos);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  onChange(value) {
    this.setState({
      ...this.state,
      cantidad: value,
    });
  }

  crearOpciones(tipoCertificacion) {
    return (
      <Option key={tipoCertificacion._id} value={tipoCertificacion._id}>
        {tipoCertificacion.nombre}
      </Option>
    );
  }

  handleChange = id_TipoCertificacion => {
    // console.log("Selecciono... ", id_TipoCertificacion);

    this.setState({
      ...this.state,
      id_TipoCertificacion: id_TipoCertificacion,
    });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onChangeCheckbox(e) {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaTiposCertificaciones = this.props.data.getTipoCertificaciones;
    if (listaTiposCertificaciones) {
      var opciones = _.map(listaTiposCertificaciones, this.crearOpciones);
    }

    return (
      <div>
        <h1 className="tituloForm">Datos de la certificacion</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Tipo Certificacion
                <Tooltip title="Seleccione el tipo de certificacion que esta realizando">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('id_TipoCertificacion', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, selecciona el tipo de certificacion.',
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Seleccione un tipo de certificacion"
                optionFilterProp="children"
                onChange={this.handleChange}
                disabled={this.state.existeVenta}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opciones}
              </Select>
            )}
          </FormItem>

          {this.props.config.creacion && (
            <FormItem>
              <Checkbox
                style={{ marginLeft: '30%' }}
                onChange={this.onChangeCheckbox}
                disabled={this.state.id_TipoCertificacion === ''}
              >
                Computar Venta
              </Checkbox>
            </FormItem>
          )}

          {!this.state.existeVenta && (
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Cantidad Certificaciones
                  <Tooltip title="La cantidad de certificaciones que abarca el tramite">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('cantidad')(
                <InputNumber
                  min={1}
                  max={100}
                  onChange={this.onChange}
                  disabled={this.state.id_TipoCertificacion === ''}
                />
              )}
            </FormItem>
          )}

          {this.state.existeVenta && (
            <div>
              <hr />
              <FormVentaSello
                opcionRender={1}
                organismo={this.props.organismo}
                onFinalizar={this.onFinalizar}
                crearVentaCompleta={this.crearVentaCompleta}
                crearVentaMercadoPago={(detalles, datosMP, extras) =>
                  this.setState({ loading: true }, () =>
                    this.onFinalizarMP(detalles, datosMP, extras)
                  )
                }
                loading={this.props.loading}
                usuario={this.props.usuario}
                tramite={'CERTIFICACIONES'}
              />
              <hr />
            </div>
          )}

          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              loading={this.props.loading}
              disabled={
                this.state.existeVenta || this.state.id_TipoCertificacion === ''
              }
            >
              <Icons.SolutionOutlined />
              Exento
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      id_TipoCertificacion: Form.createFormField({
        value: props.datos ? props.datos.id_TipoCertificacion : '',
      }),
      cantidad: Form.createFormField({
        value: props.datos ? props.datos.cantidad : 0,
      }),
    };
  },
})(FormCertificacion);
